
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad",
      function () {
        return require("private-next-pages/ad.js");
      }
    ]);
  